export type MediaType = 'movie' | 'tv' | 'variety';

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  cover: string;
  backdrop?: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  cast: string[];
  director: string;
  duration: string;
  summary: string;
  episodes?: number;
  updatedAt: string;
  popularity: number;
  badge?: string;
  featured?: boolean;
}

export interface NewsItem {
  id: string;
  title: string;
  category: string;
  author: string;
  date: string;
  cover: string;
  summary: string;
  content: string[];
  tags: string[];
}

export const MEDIA_TYPE_LABEL: Record<MediaType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};